import React, { useState, useEffect, useContext } from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";

import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { ptBR } from "@mui/material/locale";
import createAppTheme from "./theme";
import {
	ColorModeContext,
	ColorModeProvider,
} from "./context/ColorMode/ColorModeContext";

const ThemedApp = () => {
	const [locale, setLocale] = useState();
	const { mode } = useContext(ColorModeContext);

	const theme = createAppTheme(locale, mode);

	useEffect(() => {
		const i18nlocale = localStorage.getItem("i18nextLng");
		if (!i18nlocale) return;

		const browserLocale =
			i18nlocale.substring(0, 2) + i18nlocale.substring(3, 5);

		if (browserLocale === "ptBR") {
			setLocale(ptBR);
		}
	}, []);

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<Routes />
			</ThemeProvider>
		</StyledEngineProvider>
	);
};

const App = () => {
	return (
		<ColorModeProvider>
			<ThemedApp />
		</ColorModeProvider>
	);
};

export default App;
